import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useUserContext } from 'providers/UserProvider';
import { userHasSomeRoles } from 'services/Authorization';
import strings from 'strings';
import { FPActionButton, When } from 'UI/components/atoms';
import { DateFormats } from 'UI/constants/defaults';
import { Roles } from 'UI/constants/roles';
import { toLocalTime } from 'UI/utils';

import { SendoutNoteForm } from '../SendoutNoteForm';

import { SendoutNoteContainer, StyledTypography } from './SendoutNote.styled';

const SUPERIOR_ROLES = [Roles.Operations, Roles.DataCoordinator];

export const SendoutNote = ({
  note: { createdById, createdBy, description, updatedAt, id: noteId },
  onFinishSave,
  sendoutId
}) => {
  const [user] = useUserContext();
  const [isEditing, setIsEditing] = useState(false);

  const hasSuperiorRole = userHasSomeRoles(user, SUPERIOR_ROLES);
  const canEdit = user?.id === createdById || hasSuperiorRole;

  const formattedDate = updatedAt ? toLocalTime(updatedAt).format(DateFormats.SimpleDateTime) : '-';

  const handleClickEdit = () => {
    setIsEditing(true);
  };

  const handleClickCancel = () => {
    setIsEditing(false);
  };

  const handleFinishSave = () => {
    setIsEditing(false);
    onFinishSave();
  };

  return (
    <SendoutNoteContainer>
      <Box width="100%">
        <Box display="flex" alignItems="center" gridGap={16}>
          <Typography variant="subtitle1" gutterBottom>
            {createdBy?.fullName}
          </Typography>
          <Typography variant="caption">{formattedDate}</Typography>
        </Box>

        {isEditing ? (
          <SendoutNoteForm
            description={description}
            noteId={noteId}
            onCancel={handleClickCancel}
            onFinishSave={handleFinishSave}
            sendoutId={sendoutId}
          />
        ) : (
          <StyledTypography variant="body2">{description}</StyledTypography>
        )}
      </Box>

      <When condition={!isEditing && canEdit}>
        <FPActionButton onClick={handleClickEdit} text={strings.shared.ui.edit} variant="text" />
      </When>
    </SendoutNoteContainer>
  );
};
